import * as React from "react";
import type { SVGProps } from "react";
const SvgIconLocationPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.69.8c-.45.06-.72.12-1 .21-1.43.5-2.46 1.74-2.69 3.23-.04.31-.04.87 0 1.18.16 1.06.72 2 1.58 2.64.4.31.95.57 1.45.7l.1.03.01 5.28v5.29l.08.15q.15.3.42.43c.11.05.16.06.36.06s.25 0 .36-.06q.28-.13.42-.43l.07-.15v-5.29l.01-5.28.1-.03c.35-.09.82-.28 1.14-.47.89-.54 1.56-1.44 1.81-2.46.13-.48.16-1.1.09-1.58-.27-1.75-1.6-3.11-3.35-3.4-.2-.04-.8-.06-.96-.04m-.05 1.73c-1.08.21-1.83 1-1.95 2.07-.12 1.1.58 2.13 1.68 2.47.2.06.24.07.63.07s.44 0 .63-.07c.9-.27 1.52-.97 1.66-1.87.05-.28.05-.45 0-.72-.12-.78-.63-1.45-1.32-1.76-.32-.14-.52-.18-.91-.19zM7.37 13.36c-.27.07-.93.3-1.25.43-1.83.75-3.13 1.9-3.56 3.16-.16.47-.21 1.09-.12 1.57.18 1 .87 1.96 1.99 2.73 1.55 1.06 3.68 1.7 6.29 1.91.5.04 2.06.04 2.56 0q3.13-.24 5.3-1.33Q20.22 21 21 19.85c.42-.63.6-1.19.6-1.89q0-1.42-1.22-2.6c-.81-.8-1.86-1.38-3.32-1.87-.43-.14-.48-.15-.68-.16-.19 0-.23.01-.35.07q-.29.13-.4.39c-.2.39-.09.84.26 1.09.06.04.3.13.6.24.58.19.98.35 1.38.56 1.28.66 2.03 1.5 2.03 2.28 0 1.5-2.47 2.95-5.74 3.39-.81.1-1.06.12-2.16.12s-1.35-.02-2.16-.12c-2.17-.3-4.06-1.04-5.03-2-.95-.93-.94-1.9.05-2.8.63-.6 1.45-1.04 2.64-1.43.32-.1.55-.2.6-.24.36-.25.47-.7.28-1.09-.18-.36-.6-.55-1-.43"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconLocationPin;
